import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './locales/en.json'
import usLocal from './locales/zh-CN.json'
//同时引⼊element国际化⽂件国际化组件
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZHLocale from 'element-ui/lib/locale/lang/zh-CN'
Vue.use(VueI18n)
const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh_CN: {
    ...usLocal,
    ...elementZHLocale
  }
}
const i18n = new VueI18n({
  locale: sessionStorage.getItem('lang') || 'zh_CN',
  messages
})
export default i18n
